$(document).ready(function(){
  isHomepage = $('body').hasClass('standardMode');
	if(isHomepage){
		var checkThirdWidgetone = $('#cookieBanner').length;
		if(checkThirdWidgetone){
			$('body').addClass('cookiebanneradded');
		} else {
			$('body').addClass('cookiebanneradded');
		}
	}
    $(".generalmessage").prependTo(".header");
        //prepend general message into header
        if ( $("body").hasClass("generalMessageOn") ) {
            $(".generalmessage").prependTo(".header");
        }
    
        // footer logo
        $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');

        //Append countdown
        if ($(window).width() < 801) {
          $( "#siteInfoBannerWidget" ).insertBefore( ".multi-wrap" );
          
        } else {
      
          $( "#siteInfoBannerWidget" ).prependTo( ".main-content-inner" );
        }


        $(".cross").click(function(){
            $("#cookieBanner").hide();
           $('body').removeClass('cookiebanneradded');
          });
          

     
});

$(window).load(function(){
 //Append countdown
 
  if ($(window).width() < 801) {
    $( "#siteInfoBannerWidget" ).insertBefore( ".multi-wrap" );
    
  } else {

    $( "#siteInfoBannerWidget" ).prependTo( ".main-content-inner" );
  }


    // Cookie Things
    var subscribeBar = $('#cross');
  
    if (navigator.cookieEnabled && subscribeBar) {
      if (Cookies.get('subscribe')) {
        return false;
      } else {
        Cookies.set('subscribe', 'subscribe', {expires:60});
        subscribeBar.css('display', 'flex');
      }
    }
  });

$(window).resize(function(){
  if ($(window).width() < 801) {
    $( "#siteInfoBannerWidget" ).insertBefore( ".multi-wrap" );
    
  } else {

    $( "#siteInfoBannerWidget" ).prependTo( ".main-content-inner" );
  }

});
